import CompanyInputs from './CompanyInputs.component';

export default CompanyInputs;
